import { TimeZone } from '../../../../ProfileStore/Types';
import { AlreadyTranslatedText, TPlainTextKey } from '../../../../Translations';

export interface Waiting {
  kind: 'waiting';
}

export interface Ready {
  kind: 'ready';
  termsAcceptance: boolean;
  emailAddress: string;
  timeZone: string;
  timeZoneOptions: ReadonlyArray<TimeZone>;
}

export interface ReadyWithClientErrors {
  kind: 'ready-with-client-errors';
  termsAcceptance: boolean;
  message: TPlainTextKey;
  emailAddress: string;
  timeZone: string;
  timeZoneOptions: ReadonlyArray<TimeZone>;
}

export interface ReadyWithServerErrors {
  kind: 'ready-with-server-errors';
  termsAcceptance: boolean;
  message: AlreadyTranslatedText;
  emailAddress: string;
  timeZone: string;
  timeZoneOptions: ReadonlyArray<TimeZone>;
}

export interface Creating {
  kind: 'creating';
  emailAddress: string;
  timeZone: string;
}

export interface Created {
  kind: 'created';
  emailAddress: string;
}

export interface ServerError {
  kind: 'server-error';
  message: AlreadyTranslatedText;
  termsAcceptance: boolean;
  emailAddress: string;
  timeZone: string;
  timeZoneOptions: ReadonlyArray<TimeZone>;
}

export interface Error {
  kind: 'error';
  message: TPlainTextKey;
  termsAcceptance: boolean;
  emailAddress: string;
  timeZone: string;
  timeZoneOptions: ReadonlyArray<TimeZone>;
}

export type State =
  | Waiting
  | Ready
  | ReadyWithClientErrors
  | ReadyWithServerErrors
  | Creating
  | Created
  | Error
  | ServerError;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const ready = (
  termsAcceptance: boolean,
  emailAddress: string,
  timeZoneOptions: ReadonlyArray<TimeZone> = [],
): Ready => ({
  kind: 'ready',
  termsAcceptance,
  emailAddress,
  timeZone: '',
  timeZoneOptions,
});

export const readyWithClientErrors = (
  termsAcceptance: boolean,
  message: TPlainTextKey,
  emailAddress: string,
  timeZone: string,
  timeZoneOptions: ReadonlyArray<TimeZone>,
): ReadyWithClientErrors => ({
  kind: 'ready-with-client-errors',
  termsAcceptance,
  message,
  emailAddress,
  timeZone,
  timeZoneOptions,
});

export const readyWithServerErrors = (
  termsAcceptance: boolean,
  message: AlreadyTranslatedText,
  emailAddress: string,
  timeZone: string,
  timeZoneOptions: ReadonlyArray<TimeZone>,
): ReadyWithServerErrors => ({
  kind: 'ready-with-server-errors',
  termsAcceptance,
  message,
  emailAddress,
  timeZone,
  timeZoneOptions,
});

export const creating = (emailAddress: string, timeZone: string): Creating => ({
  kind: 'creating',
  emailAddress,
  timeZone,
});

export const created = (emailAddress: string): Created => ({
  kind: 'created',
  emailAddress,
});

export const error = (
  message: TPlainTextKey,
  termsAcceptance: boolean,
  emailAddress: string,
  timeZone: string,
  timeZoneOptions: ReadonlyArray<TimeZone>,
): Error => ({
  kind: 'error',
  message,
  termsAcceptance,
  emailAddress,
  timeZone,
  timeZoneOptions,
});

export const serverError = (
  message: AlreadyTranslatedText,
  termsAcceptance: boolean,
  emailAddress: string,
  timeZone: string,
  timeZoneOptions: ReadonlyArray<TimeZone>,
): ServerError => ({
  kind: 'server-error',
  message,
  termsAcceptance,
  emailAddress,
  timeZone,
  timeZoneOptions,
});
